// Extracted membership details are unvalidated; validation status belongs to the API response.
export type CheckoutFrequentFlyer = Omit<App.FrequentFlyer, 'is_valid'>

export function haveFrequentFlyerDetailsChanged(previous: App.Checkout.TravellerForm, next: App.Checkout.TravellerForm): boolean {
  const previousPrograms = extractCheckoutFrequentFlyers(previous, [])
  const nextPrograms = extractCheckoutFrequentFlyers(next, [])
  if (!previousPrograms.length && !nextPrograms.length) return false

  return previous.data.firstName !== next.data.firstName ||
    previous.data.lastName !== next.data.lastName ||
    JSON.stringify(previousPrograms) !== JSON.stringify(nextPrograms)
}

export function extractCheckoutFrequentFlyers(form: App.Checkout.TravellerForm, carrierCodes: Array<string>) {
  const programNumbers: Array<CheckoutFrequentFlyer> = []

  // For two one-ways there is a possibility of having different carriers for
  // each leg.
  // frequentFlyerAirline1 is departing
  if (form.data.frequentFlyerAirline1 && form.data.frequentFlyerNumber1) {
    programNumbers.push({
      booking_carrier: carrierCodes[0],
      number: form.data.frequentFlyerNumber1,
      program_carrier: form.data.frequentFlyerAirline1,
    })
  }

  // frequentFlyerAirline2 is returning
  if (form.data.frequentFlyerAirline2 && form.data.frequentFlyerNumber2) {
    programNumbers.push({
      booking_carrier: carrierCodes[1],
      number: form.data.frequentFlyerNumber2,
      program_carrier: form.data.frequentFlyerAirline2,
    })
  }

  if (form.data.qantasFrequentFlyerNo) {
    programNumbers.push({
      booking_carrier: 'QF',
      program_carrier: 'QF',
      number: form.data.qantasFrequentFlyerNo,
    })
  }

  if (form.data.velocityFrequentFlyerNo) {
    programNumbers.push({
      booking_carrier: 'VA',
      program_carrier: 'VA',
      number: form.data.velocityFrequentFlyerNo,
    })
  }

  return programNumbers
}

export function loyaltyProgramNumbers(form: App.Checkout.TravellerForm, carrierCodes: Array<string>) {
  const programNumbers = extractCheckoutFrequentFlyers(form, carrierCodes)

  if (programNumbers.length === 0) {
    return {}
  }

  // Preserve the existing booking contract; this flag is not evidence of API validation.
  return {
    loyalty_program_numbers: {
      frequent_flyer: programNumbers.map(program => ({ ...program, is_valid: true })),
    },
  }
}

export function toSeatsLoyaltyProgramNumbers(programs: Array<CheckoutFrequentFlyer>) {
  if (programs.length === 0) return undefined

  return {
    frequentFlyer: programs.map(program => ({
      bookingCarrier: program.booking_carrier,
      programCarrier: program.program_carrier,
      number: program.number,
    })),
  }
}

export function toFrequentFlyerValidationTravelers(
  programs: Array<CheckoutFrequentFlyer>,
  traveller: { givenName: string; surname: string; passengerType: 'ADT' | 'CHD' | 'INF' },
) {
  return programs.map(program => ({
    partnerAirline: program.program_carrier,
    frequentFlyerNumber: program.number,
    givenName: traveller.givenName,
    surname: traveller.surname,
    passengerType: traveller.passengerType,
  }))
}
